import { MaintenanceObjectiveSystemData } from "../types/MaintenanceObjectiveSystem.type";
import ActionLinkButton from "@/common/components/ActionLinkButton";

export class MaintenanceObjectiveSystemsTransformer {

  static tableTransformer() {
    return (objectiveSystems: MaintenanceObjectiveSystemData[]) => {
      return objectiveSystems.map((objectiveSystem) => {
        return {
          ...objectiveSystem,
          actions: (
            <ActionLinkButton
              linkTo={objectiveSystem.id}
              operationKlassToCheckPermission="Admin::Maintenance::ObjectiveSystems::Show"
              dataTestid="show_button"
            />
          ),
        }
      });
    }
  }

}
